import request from '../../../api/request';

import {
  HomologationFormDataResponse,
  HomologationListFilter,
  HomologationListResponse,
} from './types';

const AUTHORIZATION = {
  FORM: '/maintainers-portal/homologation/authorizations/form',
  LIST: '/maintainers-portal/homologation/authorizations',
};

export function getAuthorizationFormData() {
  return request<HomologationFormDataResponse>(AUTHORIZATION.FORM);
}

export function getAuthorizationRequests(params: HomologationListFilter) {
  return request<HomologationListResponse>(AUTHORIZATION.LIST, {
    params,
  });
}
